const CategorySkeleton = () => (
    <div className="relative flex items-center overflow-hidden border border-slate-400 rounded py-3 cursor-pointer animate-pulse">
        <div className="mx-4 text-base z-10 h-5 bg-slate-300 w-2/3 rounded"></div>
    </div>
);

export default CategorySkeleton;